import { Formik } from "formik";
import React from "react";
import * as Yup from "yup";
import InfiniteDotLoader from "../../../../utils/InfiniteDotLoader";
import CommonInput from "../../../Layouts/CommonInput";
import Style from "./ResetPasswordForm.module.scss";

let hasErrors = false;

// otpError = { otpError };
const ResetPasswordForm = ({
  initData,
  resetPassword,
  passwordCheck,
  hasPasswordUpdated,
  isLoading,
  otpError,
}) => {
  const SignupSchema = Yup.object().shape({
    newPassword: Yup.string()
      .required("Password is required.")
      .min(6, "Password length must be a minimum of six."),
    confirmPassword: Yup.string()
      .required("Confirm Password is required.")
      .min(6, "Password length must be a minimum of six."),
  });

  return (
    <Formik
      initialValues={initData}
      onSubmit={(values, { resetForm }) => {
        resetPassword(values, { resetForm });
      }}
      validationSchema={SignupSchema}
      enableReinitialize={true}
    >
      {({
        errors,
        touched,
        values,
        handleBlur,
        handleSubmit,
        setFieldValue,
        dirty,
        isValid,
      }) => {
        hasErrors = Object.keys(errors).length == 0;
        return (
          <>
            <CommonInput
              label="Enter Password"
              variant="password-visibility-toggle"
              placeholder="Enter password"
              id="newPassword"
              value={values?.newPassword}
              onBlur={handleBlur}
              onChange={(e) => {
                setFieldValue("newPassword", e.target.value);
              }}
              hasError={errors?.newPassword && touched?.newPassword}
              errorMsg={errors?.newPassword}
              autoComplete="new-password"
            />

            <CommonInput
              label="Re-enter Password"
              variant="password-visibility-toggle"
              placeholder="Re-enter Password"
              id="confirmPassword"
              value={values?.confirmPassword}
              onBlur={handleBlur}
              onChange={(e) => {
                setFieldValue("confirmPassword", e.target.value);
              }}
              hasError={errors?.confirmPassword && touched?.confirmPassword}
              errorMsg={errors?.confirmPassword}
              autoComplete="new-password"
            />
            <p className="text-danger">
              {passwordCheck === "error" && "Passwords are not matching."}
            </p>
            <p className="text-success">
              {hasPasswordUpdated &&
                "Your password has been reset successfully."}
            </p>
            <p className={Style.otp_open_error}>{otpError}</p>
            <button
              onClick={() => handleSubmit()}
              type="button"
              disabled={!isValid || !dirty}
              className={`${Style.ForgotPassword__button} btn btn-primary w-100`}
            >
              {isLoading === "loading" ? (
                <InfiniteDotLoader />
              ) : (
                "Reset Password"
              )}
            </button>
          </>
        );
      }}
    </Formik>
  );
};

export default ResetPasswordForm;
